import {gql} from "@apollo/client";
import {Garage} from "@App/types";

export interface GarageDetailsQuery {
    garage: Garage
}

export const GET_GARAGE_DETAILS_QUERY = gql`
    query getGarageDetails($id:ID!)  {
        garage(id: $id) {
            id
            uuid
            name
            description
            nationwide_service
            rating
            street
            city
            postcode
            images {
                id
                path
            }
            opening_hours {
                day
                open
            }
            checkpoint {
                id
                name
                logo
            }
        }
    }
`
